import BaseStore from './base-store'
import {API2_AUDIT_CLIENT} from 'consts/api2'
import StoreProxy from './store_proxy'

class Settings extends BaseStore {
  constructor() {
    super({
      client_id: undefined,
      client_secret: undefined
    })
  }

  async doLoad(rest, params) {
    // curl --location --request POST 'https://genrate-dev.auth.us-east-1.amazoncognito.com/oauth2/token' \
    // --header 'Authorization: Basic MTRmazBjdXZtNzFmZXY1NGhyOWZvNGdrOTM6MXFmZXBlYmRqbjc0MWZxOWpzYTFybmpuM3JvaTY5ZTRlMTlwMjVwbWd0bDJsZ3B2amgzNA==' \
    // --header 'Content-Type: application/x-www-form-urlencoded' \
    // --data-urlencode 'grant_type=client_credentials'
    const settings = await rest.get(API2_AUDIT_CLIENT, params, {throw_404: false})
    this._state.client_id = settings?.client_id
    this._state.client_secret = settings?.client_secret
  }

  async createClient() {
    const client = await this._rest.post(API2_AUDIT_CLIENT)
    this._state.client_id = client.client_id
    this._state.client_secret = client.client_secret
  }

  async deleteClient() {
    await this._rest.delete(`${API2_AUDIT_CLIENT}`)
    this._state.client_id = undefined
    this._state.client_secret = undefined
  }
}

const settings = new StoreProxy(new Settings())
export default settings
